/**
 * components/landing/launch-platform/LaunchPlatformPage.jsx — Phase 6.
 */

import SiteFrame from '@/components/landing/SiteFrame'
import Hero          from './sections/Hero'
import WhyWL         from './sections/WhyWL'
import Opportunity   from './sections/Opportunity'
import WhatYouReceive from './sections/WhatYouReceive'
import Branding      from './sections/Branding'
import Workspace     from './sections/Workspace'
import LaunchWorkflow from './sections/LaunchWorkflow'
import Subscription  from './sections/Subscription'
import Admin         from './sections/Admin'
import Growth        from './sections/Growth'
import Scenarios     from './sections/Scenarios'
import FAQ           from './sections/FAQ'
import FinalCTA      from './sections/FinalCTA'

const LaunchPlatformPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />
    <WhyWL />
    <Opportunity />
    <WhatYouReceive />
    <Branding />
    <Workspace />
    <LaunchWorkflow />
    <Subscription />
    <Admin />
    <Growth />
    <Scenarios />
    <FAQ />
    <FinalCTA />
  </SiteFrame>
)

export default LaunchPlatformPage
